import React, { useEffect, useState } from 'react'
import './AllUser.css'
import { Box, Button, Grid2 } from '@mui/material'
import Header from '../Header/Header'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import { useNavigate, useLocation } from 'react-router-dom';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CreateAgent from '../CreateAgent/CreateAgent';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Chip from '@mui/material/Chip';
import Pagination from '@mui/material/Pagination';
import TextField from '@mui/material/TextField';

const drawerWidth = 260;

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}

const rows = [
    createData('Frozen yoghurt', 159, 6.0, 27849.00, 4.0),
    createData('Ice cream sandwich', 237, 9.0, 27849.00, 4.3),
    createData('Eclair', 262, 16.0, 27849.00, 6.0),
    createData('Cupcake', 305, 3.7, 27849.00, 4.3),
    createData('Gingerbread', 356, 16.0, 27849.00, 3.9),
];

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


function AllUser() {

    const [value, setValue] = useState(0);

    const navigate = useNavigate()

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue === 0) {
            navigate('/alluser')
        }
        else if (newValue === 1) {
            navigate('/allagent')
        } else if (newValue === 2) {
            navigate('/players')
        }
    };

    const theme = useTheme();
    const lgMatches = useMediaQuery(theme.breakpoints.up('lg'));

    const result = useLocation()
    const date = result.pathname

    console.log(date, 'date');

    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });


    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };
    const list = (anchor) => (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }} sx={{ height: '100vh' }}>
                <Box sx={{ width: '100%', background: "#323030", height: '100%', borderRadius: lgMatches && '10px' }}>


                    <div className=" padding-10 display-2 flex-wrap">
                        <div className="agent-h">
                            Agents
                        </div>
                        <HighlightOffIcon sx={{ fill: '#fff' }} onClick={toggleDrawer(anchor, false)} />
                    </div>
                    <div className="mt-10 display-2 padding-10 agent-lay2 cursor">
                        <div className="display-1">
                            <div className="display-1">
                                <ContactEmergencyIcon sx={{ fill: '#fff' }} />
                            </div>
                            <div className="agent-name">
                                Agent-Lavanya
                            </div>
                        </div>
                        <div className='display-1'>
                            <ArrowDropDownIcon sx={{ fill: '#fff' }} />
                        </div>
                    </div>
                </Box>
            </Grid2>
        </Box>
    );

    useEffect(() => {
        if (date === '/alluser') {
            setValue(0)
        } else if (date === '/allagent') {
            setValue(1)
        } else if (date === '/players') {
            setValue(2)
        }
    }, [date])

    return (
        <div className='all-user'>
            <Box sx={{ display: 'flex' }}>
                <Header />
                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: !lgMatches ? 1 : 5, width: { sm: `calc(100% - ${drawerWidth}px)` }, marginTop: '50px' }}
                >

                    <Grid2 container spacing={2}>

                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <div className=" padding-10 display-2 flex-wrap">
                                <div className="agent-h">
                                    Users
                                </div>
                                <CreateAgent />
                            </div>
                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 9, xl: 9 }} sx={{ height: '100vh' }}>
                            <Box sx={{ width: '100%', background: "#323030", height: '100%', borderRadius: '10px' }}>
                                <Box sx={{}}>
                                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className='bet-tab'>
                                        <Tab label="  All Users" {...a11yProps(0)} />
                                        <Tab label=" Agents" {...a11yProps(1)} />
                                        <Tab label="Players" {...a11yProps(2)} />
                                    </Tabs>
                                </Box>
                                <CustomTabPanel value={value} index={0}>
                                    <div className="agent-h">
                                        Filter
                                    </div>
                                    <div className="display-2">
                                        <div className='display-1 filter'>
                                            <div className='pop-txt'>
                                                <TextField id="outlined-basic" placeholder="User ID " variant="outlined" />
                                            </div>
                                            <div className='pop-txt'>
                                                <TextField id="outlined-basic" placeholder="User Name" variant="outlined" />
                                            </div>
                                        </div>
                                        <div className="display-3" style={{ gap: '10px' }}>
                                            <div className="topup">
                                                <Button>Clear</Button>
                                            </div>
                                            <div className="withdraw">
                                                <Button>Search</Button>
                                            </div>
                                        </div>
                                    </div>


                                    <TableContainer className='agent-table mt-20'>
                                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>User</TableCell>
                                                    <TableCell align="center">ID</TableCell>
                                                    <TableCell align="center">ROLE</TableCell>
                                                    <TableCell align="center">Balance</TableCell>
                                                    <TableCell align="center">Operations/Actions</TableCell>
                                                    <TableCell align="center"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rows.map((row) => (
                                                    <TableRow
                                                        key={row.name}
                                                        sx={{ border: 0 }}
                                                    >
                                                        <TableCell >
                                                            {row.name}
                                                        </TableCell>
                                                        <TableCell align="center">{row.calories}</TableCell>
                                                        <TableCell align="center">{<Chip label="Player" color='success' />}</TableCell>
                                                        <TableCell align="center">$ {row.carbs}</TableCell>
                                                        <TableCell align="center">
                                                            <div className="display-3" style={{ gap: '10px' }}>
                                                                <div className="topup">
                                                                    <Button>Top-Up</Button>
                                                                </div>
                                                                <div className="withdraw">
                                                                    <Button>Withdraw</Button>
                                                                </div>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <div className='pagei'>
                                            <Pagination count={10} size="small" />
                                        </div>
                                    </TableContainer>
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={1}>
                                    Agents
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={2}>
                                    Players
                                </CustomTabPanel>
                            </Box>
                        </Grid2>

                        {lgMatches && <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }} sx={{ height: '100vh' }}>
                            <Box sx={{ width: '100%', background: "#323030", height: '100%', borderRadius: '10px' }}>
                                <div className="agent-h padding-10 ">
                                    Agents
                                </div>
                                <div className="mt-10 display-2 padding-10 agent-lay2 cursor">
                                    <div className="display-1">
                                        <div className="display-1">
                                            <ContactEmergencyIcon sx={{ fill: '#fff' }} />
                                        </div>
                                        <div className="agent-name">
                                            Agent-Lavanya
                                        </div>
                                    </div>
                                    <div className='display-1'>
                                        <ArrowDropDownIcon sx={{ fill: '#fff' }} />
                                    </div>
                                </div>
                            </Box>
                        </Grid2>}
                    </Grid2>

                </Box>

            </Box>


            {['bottom'].map((anchor) => (
                <React.Fragment key={anchor}>
                    {/* <Button >{anchor}</Button> */}
                    {!lgMatches && <div className="agent-tree">
                        <Button onClick={toggleDrawer(anchor, true)}>
                            Agent Tree
                        </Button>
                    </div>}
                    <SwipeableDrawer
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                        onOpen={toggleDrawer(anchor, true)}
                    >
                        {list(anchor)}
                    </SwipeableDrawer>
                </React.Fragment>
            ))}
        </div>
    )
}

export default AllUser
